import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "d-flex flex-wrap ga-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_menu = _resolveComponent("v-menu")!

  return (_openBlock(), _createBlock(_component_v_menu, { location: "bottom start" }, {
    activator: _withCtx(({props}) => [
      _renderSlot(_ctx.$slots, "activator", _normalizeProps(_guardReactiveProps({props})), () => [
        _createVNode(_component_v_btn, _mergeProps(props, {
          variant: "text",
          icon: "",
          size: "small",
          title: _ctx.title
        }), {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, {
              size: "small",
              color: _ctx.modelValue || _ctx.fallback
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.modelValue ? _ctx.VALUE_DOT : 'mdi-circle-outline'), 1)
              ]),
              _: 1
            }, 8, ["color"])
          ]),
          _: 1
        }, 16, ["title"])
      ], true)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_v_sheet, { class: "pa-2 color-swatch-menu" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (_ctx.clearable)
              ? (_openBlock(), _createBlock(_component_v_btn, {
                  key: 0,
                  variant: "text",
                  icon: "",
                  size: "small",
                  title: _ctx.$tt('color-automatic'),
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', '')))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, { color: _ctx.fallback }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.modelValue ? 'mdi-circle-outline' : 'mdi-check-circle-outline'), 1)
                      ]),
                      _: 1
                    }, 8, ["color"])
                  ]),
                  _: 1
                }, 8, ["title"]))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.palette, (color) => {
              return (_openBlock(), _createBlock(_component_v_btn, {
                key: color,
                variant: "text",
                icon: "",
                size: "small",
                title: color,
                onClick: ($event: any) => (_ctx.$emit('update:modelValue', color))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, { color: color }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(color === _ctx.modelValue ? 'mdi-check-circle' : _ctx.usedBy(color) ? 'mdi-circle-slice-8' : 'mdi-circle'), 1)
                    ]),
                    _: 2
                  }, 1032, ["color"])
                ]),
                _: 2
              }, 1032, ["title", "onClick"]))
            }), 128))
          ])
        ]),
        _: 1
      })
    ]),
    _: 3
  }))
}